import { Controller } from "@hotwired/stimulus"

// Toggles a companion table row open/closed — e.g. the per-section documents
// row in the Manage Resources hub. Sits on the <tbody> (alongside sortable);
// each trigger button passes the parent row's id as an action param:
//
//   <button data-action="row-expand#toggle" data-row-expand-id-param="42"
//           aria-expanded="false">…</button>
//   <tr data-child-of="42" class="d-none">…</tr>
//
// The companion row starts hidden (d-none), so a lazy turbo-frame inside it
// never fetches while collapsed. Opening switches any lazy frame to eager, so
// it fetches on the click itself — Turbo's lazy IntersectionObserver alone
// waits until the frame scrolls into view, which left a row that expands
// below the fold (a phone) showing "Loading…" until the user scrolled (#15268).
// aria-expanded mirrors state on the trigger for keyboard/AT users.
export default class extends Controller {
  toggle(event) {
    const trigger = event.currentTarget
    const id = event.params.id
    const row = this.element.querySelector(`[data-child-of="${CSS.escape(String(id))}"]`)
    if (!row) return

    const opening = row.classList.contains("d-none")
    row.classList.toggle("d-none", !opening)
    trigger.setAttribute("aria-expanded", String(opening))
    if (opening) this.#loadLazyFrames(row)

    const icon = trigger.querySelector("i")
    if (icon) {
      icon.classList.toggle("ph-caret-down", !opening)
      icon.classList.toggle("ph-caret-up", opening)
    }
  }

  // Turbo observes the `loading` attribute: lazy → eager loads the src now.
  #loadLazyFrames(row) {
    row.querySelectorAll('turbo-frame[loading="lazy"]').forEach((frame) => {
      frame.setAttribute("loading", "eager")
    })
  }
}
